// extracted by css-extract-rspack-plugin
export default {"root":"root-QQ4wy_","avatar":"avatar-ivSHhq","name":"name-U0k6RW"};